import React from "react";

export default ({ cardList = [] }) => { 
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-3 md:gap-4 justify-items-center">
            {
                cardList.map((card) => (
                    <div 
                        key={card.cardTmpId}
                        className="w-full min-w-[280px] max-w-[360px] bg-white border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow active:scale-[0.98]"
                    >
                        {/* 次卡名称 */}
                        <div className="text-base font-bold text-gray-800 mb-2 truncate">
                            {card.title}
                        </div>
                        
                        {/* 商品名称 */}
                        <div className="text-sm text-gray-600 mb-3">
                            <span className="text-gray-500">适用商品:</span>{' '}
                            <span className="truncate block mt-1">
                                {card.good?.title?.substring(0, 15)}{card.good?.title?.length > 15 ? '...' : ''}
                            </span>
                        </div>
                        
                        {/* 规格信息 */}
                        {card.goods_card_skus && card.goods_card_skus.length > 0 && (
                            <div className="space-y-1 mb-3">
                                {card.goods_card_skus.slice(0, 2).map((sku, index) => (
                                    <div key={index} className="flex items-center text-xs">
                                        <span className="text-gray-500 mr-2">{sku.title}:</span>
                                        <span className="font-medium">{sku.times}次 / ¥{(sku.price / 100).toFixed(2)}</span>
                                    </div>
                                ))}
                                {card.goods_card_skus.length > 2 && (
                                    <div className="text-xs text-gray-400">+{card.goods_card_skus.length - 2}个更多规格</div>
                                )}
                            </div>
                        )}
                        
                        {/* 操作按钮 */}
                        <div className="pt-3 border-t border-gray-100">
                            <a 
                                href={`/promotion/goods-card-template/create?cardTmpId=${card.cardTmpId}&action=edit`}
                                className="text-blue-600 hover:text-blue-700 text-sm font-medium"
                            >
                                编辑
                            </a>
                        </div>
                    </div>
                ))
            }
        </div>
    );
};